import {I18n} from 'aws-amplify/utils';

import {Button,} from '@mantine/core';

import {AiOutlineMail} from 'react-icons/ai'
import { useState } from 'react';
import { ComposeEmailDrawer } from '../drawers/ComposeEmailDrawer';


export const AddRecordButton = ({
                                    buttonText = 'Send Message',
                                    size = 'sm',
                                    aliasId,
                                }: {
    buttonText?: string,
    size?: string,
    aliasId?: string
}) => {
    const [drawerOpened, setDrawerOpened] = useState(false);

    return (
        <>
            <Button
                variant={"filled"}
                disabled={false}
                leftSection={<AiOutlineMail/>}
                onClick={() => setDrawerOpened(true)}
                size={size}
            >
                {I18n.get(buttonText)}
            </Button>
            <ComposeEmailDrawer
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
                aliasId={aliasId}
            />
        </>
    );
};